/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1725
 */

"use strict"

var r = require(/* 86 */"../1650/86/index")
var /* [auto-meaningful-name] */require_761_$$_1648_761_index$trim = require(/* 761 */"../1648/761/index").trim
r({
  target: "String",
  proto: true,
  forced: require(/* 1099 */"./1099")("trim")
}, {
  trim: function () {
    return require_761_$$_1648_761_index$trim(this)
  }
})
